import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
import { useRef, useEffect, useState } from "react";
import client1 from "../../common/images/client-1.png";
import client2 from "../../common/images/client-2.png";
import client3 from "../../common/images/client-3.png";
import client4 from "../../common/images/client-4.png";

export default function TestimonialSlider() {
  const prevRef = useRef(null);
  const nextRef = useRef(null);
  const [swiperInstance, setSwiperInstance] = useState(null);

  useEffect(() => {
    if (swiperInstance && swiperInstance.params.navigation) {
      swiperInstance.params.navigation.prevEl = prevRef.current;
      swiperInstance.params.navigation.nextEl = nextRef.current;
      swiperInstance.navigation.init();
      swiperInstance.navigation.update();
    }
  }, [swiperInstance]);

  return (
    <div className="relative">
      <div
        className="absolute inset-0 bg-cover w-full"
        style={{
          backgroundImage: "url('/world.png')",
          backgroundSize: "100% 100%",
        }}
      ></div>

      <section className="relative max-w-[1280px] mx-auto md:px-10 px-5 md:py-10 py-0 pt-5">
        <h3 className="text-webYellow text-3xl font-medium text-center">
          Testimonial
        </h3>
        <h2 className="text-2xl sm:text-3xl md:text-4xl small:flex-col  small:flex font-medium text-center mt-2 text-[#0A4C80] leading-snug md:leading-normal">
          Creative Web Agency Delivering <span>Custom Solutions</span>
        </h2>

        <div className="relative  mt-7">
          <Swiper
            modules={[Navigation]}
            navigation={{
              prevEl: prevRef.current,
              nextEl: nextRef.current,
            }}
            onSwiper={setSwiperInstance}
            spaceBetween={20}
            slidesPerView={1}
            breakpoints={{
              768: { slidesPerView: 2 },
              1024: { slidesPerView: 3 },
            }}
            className="pb-10"
          >
            {/* Slide 1 */}
            <SwiperSlide>
              <div
                className="p-6 rounded-xl shadow-md relative bg-cover bg-center mt-[34px] h-full"
                style={{
                  backgroundImage: "url('/testi-1.png')",
                  backgroundSize: "100% 100%",
                }}
              >
                <div className="absolute -top-8 right-0 size-20 rounded-full overflow-hidden border-2 border-white">
                  <img
                    src={client1}
                    alt="Johan Shams"
                    className="size-full object-fill"
                  />
                </div>
                <p className="text-black text-sm mt-6">
                  We are very satisfied and happy to have found Binary Ops as
                  our development partner. During our relationship, Binary Ops
                  has developed a good understanding of our own vision and work
                  flows and found a way to successfully complement our
                  operations without causing any discontinuities or issues on
                  our side.
                </p>
                <h4 className="font-bold text-webOranage mt-4">
                  Shahzad Akbar
                </h4>
                <p className="text-sm text-secondary font-semibold">
                  Founder Izmir Bar Grill
                </p>
              </div>
            </SwiperSlide>

            {/* Slide 2 */}
            <SwiperSlide>
              <div
                className="p-6 rounded-xl shadow-md relative bg-cover bg-center mt-[34px] h-full"
                style={{
                  backgroundImage: "url('/testi-2.png')",
                  backgroundSize: "100% 100%",
                }}
              >
                <div className="absolute -top-8 right-0 size-20 rounded-full overflow-hidden border-2 border-white">
                  <img
                    src={client2}
                    alt="Johan Shams"
                    className="size-full object-fill"
                  />
                </div>
                <p className="text-white text-sm mt-6">
                  I am very pleased with your Project Management capability.
                  Your team has excellent communication skills and a fast
                  response and turnaround time. Highest work quality. I can say
                  that Binary Ops is an honest and decent group of people with
                  the highest work ethic I have seen for development team.
                </p>
                <h4 className="font-bold text-webOranage mt-4">Reza</h4>
                <p className="text-sm text-white">CEO, Italian Pizzas</p>
              </div>
            </SwiperSlide>

            {/* Slide 3 */}
            <SwiperSlide>
              <div
                className="p-6 rounded-xl shadow-md relative bg-cover bg-center mt-[34px] h-full"
                style={{
                  backgroundImage: "url('/testi-1.png')",
                  backgroundSize: "100% 100%",
                }}
              >
                <div className="absolute -top-8 right-0 size-20 rounded-full overflow-hidden border-2 border-white">
                  <img
                    src={client4}
                    alt="Johan Shams"
                    className="size-full object-fill"
                  />
                </div>
                <p className="text-black text-sm mt-6">
                  This is due to their excellent service, competitive pricing
                  and customer support. It’s thoroughly refreshing to get such a
                  personal touch.
                </p>
                <h4 className="font-bold text-webOranage mt-4">Sultan Raja</h4>
                <p className="text-sm text-secondary font-semibold">
                  CEO, Global Parking Management
                </p>
              </div>
            </SwiperSlide>

            {/* Slide 4 */}
            <SwiperSlide>
              <div
                className="p-6 rounded-xl shadow-md relative bg-cover bg-center mt-[34px] h-full"
                style={{
                  backgroundImage: "url('/testi-2.png')",
                  backgroundSize: "100% 100%",
                }}
              >
                <div className="absolute -top-8 right-0 size-[70px] rounded-full overflow-hidden border-2 border-white">
                  <img
                    src={client3}
                    alt="Johan Shams"
                    className="size-full object-fill"
                  />
                </div>
                <p className="text-white text-sm mt-6">
                  Binary Ops has been providing Managed Services for Compare
                  parking for more than a year. They’ve been managing the
                  applications effectively and develop new things within no
                  time.
                </p>
                <h4 className="font-bold text-webOranage mt-4">Raaj</h4>
                <p className="text-sm text-white font-semibold">
                  CEO, Travel Extra Deals
                </p>
              </div>
            </SwiperSlide>
          </Swiper>

          {/* Navigation Buttons */}
          <button
            ref={prevRef}
            className="swiper-button-prev absolute small:-left-8 -left-3 top-1/2 -translate-y-1/2 z-10 p-3 rounded-full"
          >
            <FaChevronLeft className="text-gray-800 text-lg" />
          </button>
          <button
            ref={nextRef}
            className="swiper-button-next absolute small:-right-8 -right-3 top-1/2 -translate-y-1/2 z-10 p-3 rounded-full"
          >
            <FaChevronRight className="text-gray-800 text-lg" />
          </button>
        </div>
      </section>
    </div>
  );
}
